import { Component, Ref, Prop, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Splide, type Options } from '@splidejs/splide';
import { URLHash as urlHash } from '@splidejs/splide-extension-url-hash';
import '@splidejs/splide/css';

import './SliderContent.scss';

@Component
export class SliderContent extends ThemeComponent {

    @Ref() splide!: HTMLDivElement | null;
    @Ref({ required: false }) thumbnails!: HTMLDivElement | null;

    @Prop() settings!: Options;

    private slider!: Splide | null;
    private thumbnailSlider!: Splide | null;
    // eslint-disable-next-line @typescript-eslint/ban-types
    private thumbnailSettings!: Object | null;

    init() {

        if (this.thumbnails) {

            // Use any settings that have been added
            // to the data attribute
            this.thumbnailSettings = {
                fixedWidth: '22%',
                gap: 10,
                rewind: true,
                pagination: false,
                isNavigation: true,
                pauseOnHover: true,
                pauseOnFocus: true,
                autoplay: false,
                interval: 1000,
                type: "loop"
            };

            const additionalThumbnailSettings = this.thumbnails.getAttribute('data-settings');

            if (additionalThumbnailSettings) {
                this.thumbnailSettings = Object.assign(this.thumbnailSettings, JSON.parse(additionalThumbnailSettings));
            }

            const settings = this.thumbnailSettings || {};

            this.thumbnailSlider = new Splide(this.thumbnails, settings);
        }

        if (this.splide) {
            this.slider = new Splide(this.splide, this.settings);
        }

        if (this.thumbnailSlider && this.slider) {
            this.slider.sync( this.thumbnailSlider  );
        }

        this.slider?.mount({ urlHash });
        this.thumbnailSlider?.mount();


    }
}
